import { ClassNameProps, Column, If, Row, StyleProps, useMediaQuery } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import {
	AnnouncementComponents,
	BigDate,
	CalendarEventComponents,
	Icon,
	ModelComponents,
	NewsletterComponents,
	Tile,
	Timeline,
	useTimelineViewerFilterSets,
} from "@s-i-s-i/see-learning.shared";
import { Main } from "../../Components";
import { homePageInfo } from "./pageinfo";
import { WelcomeBanner, WelcomeBannerPermissionRequired } from "./WelcomeBanner";
import styles from "./styles.module.css";

export function HomePage() {
	useActivePageRegistration(homePageInfo);

	const isScreenWide = useMediaQuery("(min-width: 1024px)");
	const isScreenWideEnoughForDate = useMediaQuery("(min-width: 400px)");

	return (
		<Main>
			<Row justify="spaced-start" horizontalSpacing="1.5rem">
				<Column justify="spaced-start" verticalSpacing="1.5rem" style={{ flexGrow: 1, minWidth: 0 }}>
					<Row justify="spaced-start" horizontalSpacing="3rem">
						<If condition={isScreenWideEnoughForDate}>
							<BigDate />
						</If>

						<AnnouncementComponents.ViewerAnnouncementRow style={{ flexGrow: 1, minWidth: 0 }} />
					</Row>

					<WelcomeBannerPermissionRequired>
						<WelcomeBanner />
					</WelcomeBannerPermissionRequired>

					<NewsletterComponents.NewsletterCarousel />

					<TimelineTile style={{ flexGrow: 1 }} />
				</Column>

				<If condition={isScreenWide}>
					<Column justify="spaced-start" className={styles["events-container"]}>
						<div>
							<ModelComponents.OmniCreateButton style={{ width: "100%" }}>
								<Row
									justify="spaced-center"
									align="center"
									horizontalSpacing="0.375rem"
									style={{ fontSize: "1.125rem" }}
								>
									<Icon.Plus size={20} /> Create
								</Row>
							</ModelComponents.OmniCreateButton>
						</div>

						<Tile className={styles["events-tile"]}>
							<Tile.Body style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
								<Column justify="spaced-start" verticalSpacing="1.25rem">
									<CalendarEventComponents.ViewerCalendar withBirthdays={false} />
									<CalendarEventComponents.UpcomingEvents />
								</Column>
							</Tile.Body>
						</Tile>
					</Column>
				</If>
			</Row>
		</Main>
	);
}

type TimelineTileProps = Partial<ClassNameProps & StyleProps>;

function TimelineTile({ className, style }: TimelineTileProps) {
	const { filterSetName, setFilterSetName, filter } = useTimelineViewerFilterSets();

	return (
		<Tile className={className} style={{ position: "relative", ...style }}>
			<Tile.Body style={{ paddingTop: "1.5rem" }}>
				<Timeline.ViewerFilterSetsForm
					filterSetName={filterSetName}
					setFilterSetName={setFilterSetName}
					style={{ position: "absolute", top: "1rem", right: "1rem" }}
				/>
				<Timeline filter={filter} pageSize={10} style={{ height: "100%" }} />
			</Tile.Body>
		</Tile>
	);
}
